import { observer } from 'mobx-react';
import { FC, FormEvent } from 'react';
import BackNextButtons from 'components/BackNextButtons';
import QuestionnaireAnswer from 'components/forms/QuestionnaireAnswer';
import { usePowerNavigate } from 'components/PowerNavigate';
import values from 'stores/values';
import withProgressForm, { ProgressFormProps } from 'utils/withProgressForm';

// 开户流程，job页面专业用户评估问卷的详情页
const QualificationQuestionnaire: FC<ProgressFormProps> = ({ onSubmit, $formutil }) => {
    const navigate = usePowerNavigate();

    const handleSubmit = (ev: FormEvent) => {
        onSubmit(() => {
            const storageJobInfo = values.getParams('job');

            values.mergeParams('job', {
                ...storageJobInfo,
                ...$formutil.$params
            });

            // 直接返回上一步即可，使用指定路由的方式会导致job页面go back跳转不符合预期
            navigate(-1);
        }, ev);
    };

    return (
        <form noValidate onSubmit={handleSubmit}>
            <QuestionnaireAnswer />
            <BackNextButtons sticky hidePrev />
        </form>
    );
};

export default withProgressForm({
    id: 'qualificationQuestionnaire',
    basePath: 'open',
    showProgressBar: false
})(observer(QualificationQuestionnaire));
